class VehicleSection extends window.HTMLElement {
  constructor() {
    super();
    this.lastClickedElement = null;
    this.lastClickedVehicleBlock = null;
    this.clickCount = 0;
    this.vehicleBlocks = this.querySelectorAll(".vehicle-block");
    this.addEventListeners();
  }
  addEventListeners() {
    this.vehicleBlocks.forEach((vehicleBlock) => {
      vehicleBlock.addEventListener("click", (event) => this.handleVehicleBlockClick(event, vehicleBlock));
    });
  }
  // Handle click on a vehicle block
  handleVehicleBlockClick(event, vehicleBlock) {
    event.stopPropagation();
    const allVehicleInfo = this.querySelectorAll(".vehicle-info");
    const allVehicleImgs = this.querySelectorAll("img.vehicle-image");
    allVehicleInfo.forEach((info) => {
      if (!info.classList.contains("hidden") && info.parentElement != vehicleBlock) {
        info.classList.add("hidden");
        info.classList.remove("z-[2]");
      }
    });
    allVehicleImgs.forEach((img) => {
      if (img.classList.contains("md:z-[3]") && img.parentElement != vehicleBlock) {
        img.classList.remove("md:z-[3]", "md:scale-[1.4]");
      }
    });
    const vehicleInfo = vehicleBlock.querySelector(".vehicle-info");
    const vehicleImg = vehicleBlock.querySelector("img.vehicle-image");
    if (vehicleInfo) {
      if (vehicleInfo.classList.contains("hidden")) {
        vehicleInfo.classList.remove("hidden");
        vehicleInfo.classList.add("z-[2]");
        vehicleImg.classList.add("md:z-[3]", "md:scale-[1.4]");
      } else {
        vehicleInfo.classList.add("hidden");
        vehicleInfo.classList.remove("z-[2]");
        vehicleImg.classList.remove("md:z-[3]", "md:scale-[1.4]");
      }
    }
  }
  // Handle click on the document to close any open vehicle-info
  handleDocumentClick() {
    const allVehicleInfo = this.querySelectorAll(".vehicle-info");
    const allVehicleImgs = this.querySelectorAll("vehicle-image");
    allVehicleInfo.forEach((info) => {
      info.classList.add("hidden");
      info.classList.remove("z-[2]");
    });
    allVehicleImgs.forEach((img) => {
      img.classList.remove("md:z-[3]", "md:scale-[1.4]");
    });
  }
}
window.customElements.define("vehicles-element", VehicleSection);
